import { render, staticRenderFns } from "./manage-gateways.vue?vue&type=template&id=080e3597"
import script from "./manage-gateways.vue?vue&type=script&lang=js"
export * from "./manage-gateways.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports